export default __webpack_public_path__ + "static/media/flags.6aa03a81.svg";